/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { FormWidgetWrapper } from '../../components/layout';

declare const RouteProps: import('react-router-dom').RouteComponentProps<{
  patientNumber: string;
  formName: string;
  submissionId?: string;
  0?: string;
}>;

type IdgTabsProps = {
  Form: React.ReactNode;
  Changes?: React.ReactNode;
  Scores?: React.ReactNode;
  formName: string;
  readOnly: boolean;
  embedded?: boolean;
} & typeof RouteProps;

interface TabPanelProps {
  children?: React.ReactNode;
  index: string;
  value: string;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {children}
    </div>
  );
}

const IdgTabs = (props: IdgTabsProps) => {
  const {
    match: { params },
    Form,
    Changes,
  } = props;
  const value = params[0] || 'form';

  return (
    <FormWidgetWrapper>
      <TabPanel value={value} index="form">
        {Form}
      </TabPanel>
      <TabPanel value={value} index="changes">
        {Changes}
      </TabPanel>
    </FormWidgetWrapper>
  );
};

export default IdgTabs;
